import {getCurrentYear} from '../../utils/commons'
import BestHomeClimatePicksLogo from './logo'
import {bestHomeClimatePicksUS} from './styles'

const baseConfig = {
  domainName: 'besthomeclimatepicks' as const,
  domainType: 'picks' as const,
  siteName: 'Best Home Climate Picks',
  logo: <BestHomeClimatePicksLogo className="size-10 shrink-0 tablet:size-8" />,
  favicon: '/favicons/besthomeclimatepicks.png',
}

const localeConfigs = {
  us: {
    measurementId: 'G-T1KNLS9R16',
    camelCaseUrl: 'BestHomeClimatePicks.com',
    title: (category: string, count: string) =>
      `Top ${count} ${category} ${getCurrentYear()} in the US | BestHomeClimatePicks.com – Trusted Reviews & Guides`,
    description: (_category?: string, _count?: string) =>
      `Find the best home climate solutions with expert reviews and comparisons. Upgrade your indoor comfort with trusted picks for heating, cooling, and air quality.`,
    styles: bestHomeClimatePicksUS,
  },
}

export const createConfig = (locale: string = 'us') => {
  const localeConfig = localeConfigs[locale as keyof typeof localeConfigs] || localeConfigs.us
  return {
    ...baseConfig,
    ...localeConfig,
  }
}
